import {
  AddressCreationInput, Order as GraphQLOrder,
  ParcelCreationInput as GraphQLParcelCreationInput,
  ParcelSize
} from "generated/graphql";

export type TemplateDataType = {
  FIRSTNAME: string;
  LASTNAME: string;
  ENTERPRISE: string;
  PHONENUMBER: string;
  ADDRESS: string;
  CITY: string;
  VALUE: number;
  "SIZE(S-M-L-XL-D)": ParcelSize;
  AMOUNTOCOLLECT: number;
  DESCRIPTION: string;
  CLIENTREFERENCE?: string;
  ADDITIONALINFOS: string;
};

export type TemplateResultType = {
  data: Order[];
  count: number;
  newCount: number;
  valid: number;
  invalid: number;
};

export type ParcelCreationInput = Exclude<GraphQLParcelCreationInput, "parcel_UID"> & { _id: string };

export type Order = GraphQLOrder & { isValid?: boolean; pickupAddress?: AddressCreationInput };

// @ts-ignore
export const distanceMetrixService = { current: null };

export const getContryCode = (country: string) => {
  if (["Sénégal", "Senegal"].includes(country)) return "SN";
  if (["Côte d'ivoire", "Ivory Coast"].includes(country)) return "CI";
  if (["Bénin", "Benign", "Benin"].includes(country)) return "BJ";
  if (["Guinée", "Guinea", "Guinee"].includes(country)) return "GN";
  return "CI";
};
